import { jsx as f } from "react/jsx-runtime";
import { c as l } from "react/compiler-runtime";
import { Badge as m } from "@mui/material";
function a(i) {
  const e = l(6);
  let r, o;
  e[0] !== i ? ({
    children: r,
    ...o
  } = i, e[0] = i, e[1] = r, e[2] = o) : (r = e[1], o = e[2]);
  let t;
  return e[3] !== r || e[4] !== o ? (t = /* @__PURE__ */ f(m, { ...o, children: r }), e[3] = r, e[4] = o, e[5] = t) : t = e[5], t;
}
export {
  a as Badge
};
